import { jsx as _jsx } from "react/jsx-runtime";
import { memo } from 'react';
import { useChartData } from '../../context/ChartContext';
import { useActiveSpectrumRangesViewState } from '../../hooks/useActiveSpectrumRangesViewState';
import useSpectrum from '../../hooks/useSpectrum';
import MultiplicityTreeNode from './MultiplicityTree';
function MultiplicityTreesInner({ ranges, displayerKey, }) {
    return (_jsx("g", { clipPath: `url(#${displayerKey}clip-chart-1d)`, children: ranges?.values?.map((range) => (_jsx(MultiplicityTreeNode, { range: range }, range.id))) }));
}
const MemoizedMultiplicityTrees = memo(MultiplicityTreesInner);
const emptyData = { ranges: {}, info: {}, display: {} };
export default function MultiplicityTrees() {
    const { displayerKey } = useChartData();
    const { showMultiplicityTrees } = useActiveSpectrumRangesViewState();
    const spectrum = useSpectrum(emptyData);
    if (!spectrum.ranges?.values ||
        !spectrum.display.isVisible ||
        spectrum.info?.isFid ||
        !showMultiplicityTrees) {
        return null;
    }
    return (_jsx(MemoizedMultiplicityTrees, { ranges: spectrum.ranges, displayerKey: displayerKey }));
}
